const styles = `:host chameleon-number-field::part(control) {
  text-align: center;
}`; export default styles;